import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TextFieldProps } from "@mui/material";
import { Box } from "@mui/material";
import { Dayjs } from "dayjs";

interface Props {
  value: [Dayjs | null, Dayjs | null]; 
  onChange: (newValue: [Dayjs | null, Dayjs | null]) => void;
  minDate?: Dayjs;
  maxDate?: Dayjs;
  disabled?: boolean;
  label?: string;
  size?: TextFieldProps["size"];
}

const DynamicDateRangePicker: React.FC<Props> = ({
  value,
  onChange,
  minDate,
  maxDate,
  disabled = false,
  size = "medium",
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box display="flex" gap={2}>
        <DatePicker
          label="Start Date"
          value={value[0]}
          onChange={(newValue) => onChange([newValue, value[1]])}
          minDate={minDate}
          maxDate={maxDate}
          disabled={disabled}
          slotProps={{ textField: { size } }}
        />
        <DatePicker
          label="End Date"
          value={value[1]}
          onChange={(newValue) => onChange([value[0], newValue])}
          minDate={minDate}
          maxDate={maxDate}
          disabled={disabled}
          slotProps={{ textField: { size } }}
        />
      </Box>
    </LocalizationProvider>
  );
};

export default DynamicDateRangePicker;
